/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MissingInfoSendResult } from './MissingInfoSendResult';
import {
    MissingInfoSendResultFromJSON,
    MissingInfoSendResultFromJSONTyped,
    MissingInfoSendResultToJSON,
    MissingInfoSendResultToJSONTyped,
} from './MissingInfoSendResult';

/**
 * 
 * @export
 * @interface SendMissingInfoFollowUp200Response
 */
export interface SendMissingInfoFollowUp200Response {
    /**
     * 
     */
    data: MissingInfoSendResult;
}

/**
 * Check if a given object implements the SendMissingInfoFollowUp200Response interface.
 */
export function instanceOfSendMissingInfoFollowUp200Response(value: object): value is SendMissingInfoFollowUp200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SendMissingInfoFollowUp200ResponseFromJSON(json: any): SendMissingInfoFollowUp200Response {
    return SendMissingInfoFollowUp200ResponseFromJSONTyped(json, false);
}

export function SendMissingInfoFollowUp200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMissingInfoFollowUp200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MissingInfoSendResultFromJSON(json['data']),
    };
}

export function SendMissingInfoFollowUp200ResponseToJSON(json: any): SendMissingInfoFollowUp200Response {
    return SendMissingInfoFollowUp200ResponseToJSONTyped(json, false);
}

export function SendMissingInfoFollowUp200ResponseToJSONTyped(value?: SendMissingInfoFollowUp200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MissingInfoSendResultToJSON(value['data']),
    };
}

